import { USER_SUBSCRIPTION_TYPES } from '@picsart/growth-rc/types';

var getUserSubscriptionType = function getUserSubscriptionType(userSubscription) {
  var is_subscribed = userSubscription.is_subscribed,
    tier_meta = userSubscription.tier_meta;
  if (is_subscribed) {
    if ((tier_meta === null || tier_meta === void 0 ? void 0 : tier_meta.id) === 'pro') {
      return USER_SUBSCRIPTION_TYPES.pro;
    }
    if ((tier_meta === null || tier_meta === void 0 ? void 0 : tier_meta.id) === 'plus') {
      return USER_SUBSCRIPTION_TYPES.plus;
    }
    if ((tier_meta === null || tier_meta === void 0 ? void 0 : tier_meta.id) === 'max_performance') {
      return USER_SUBSCRIPTION_TYPES.maxPerformance;
    }
    if ((tier_meta === null || tier_meta === void 0 ? void 0 : tier_meta.id) === 'max_starter') {
      return USER_SUBSCRIPTION_TYPES.maxStarter;
    }
    return USER_SUBSCRIPTION_TYPES.gold;
  }
  return USER_SUBSCRIPTION_TYPES.free;
};

export { getUserSubscriptionType as default };
//# sourceMappingURL=index.js.map
